export type JurisdictionCode = 'RU' | 'KZ' | 'BY' | 'AM'

const JURISDICTION_CODES: JurisdictionCode[] = ['RU', 'KZ', 'BY', 'AM']

export function normalizeJurisdictionCode(raw?: string | null): JurisdictionCode {
  if (!raw) {
    return 'RU'
  }
  const code = raw.toString().trim().toUpperCase() as JurisdictionCode
  if (JURISDICTION_CODES.includes(code)) {
    return code
  }
  return 'RU'
}

export function taxIdLabel(jurisdiction?: string | null, role?: string | null): string {
  const code = normalizeJurisdictionCode(jurisdiction)
  if (code === 'BY') {
    return 'УНП'
  }
  if (code === 'KZ') {
    return role === 'customer' ? 'ИИН' : 'БИН'
  }
  return 'ИНН'
}

export function hasOgrnField(jurisdiction?: string | null): boolean {
  return normalizeJurisdictionCode(jurisdiction) === 'RU'
}

/** Маска серии/номера РФ и код подразделения — только для юрисдикции RU. */
export function hasRussianPassportFields(jurisdiction?: string | null): boolean {
  return normalizeJurisdictionCode(jurisdiction) === 'RU'
}

/** react-input-mask: пустая строка = свободный ввод (буквы+цифры для РБ и др.). */
export function passportNumberReactInputMask(jurisdiction?: string | null): string {
  return hasRussianPassportFields(jurisdiction) ? '9999 999999' : ''
}

export function ogrnLabel(): string {
  return 'ОГРН'
}

export function taxIdValidationRule(jurisdiction?: string | null): string {
  const code = normalizeJurisdictionCode(jurisdiction)
  const mapping: Record<JurisdictionCode, string> = {
    RU: 'ruTaxId',
    BY: 'byUnp',
    KZ: 'kzIinBin',
    AM: 'amTaxId',
  }
  return mapping[code]
}

export function ogrnValidationRule(jurisdiction?: string | null): string | null {
  return hasOgrnField(jurisdiction) ? 'ruOgrn' : null
}

function taxIdMaskLength(jurisdiction?: string | null): number {
  const code = normalizeJurisdictionCode(jurisdiction)
  const lengths: Record<JurisdictionCode, number> = {
    RU: 12,
    BY: 9,
    KZ: 12,
    AM: 8,
  }
  return lengths[code]
}

/** IMask / TextFieldMasked / FormInput — `0` = слот для цифры */
export function taxIdInputMask(jurisdiction?: string | null): string {
  return '0'.repeat(taxIdMaskLength(jurisdiction))
}

/** react-input-mask (UpdateUserFields) — `9` = слот для цифры */
export function taxIdReactInputMask(jurisdiction?: string | null): string {
  return '9'.repeat(taxIdMaskLength(jurisdiction))
}
